import { NavigationItem } from '../types/navigation';

export const navigationItems: NavigationItem[] = [
  {
    id: 'ie-rnd-kpi',
    label: 'Top Level KPIs',
    path: '/top-level-kpi',
    icon: 'Speed',
    roles: ['Admin', 'Leadership', 'ScrumMaster', 'Developer', 'Guest'],
  },
  {
    id: 'leadership',
    label: 'Leadership Dashboard',
    path: '/leadership',
    icon: 'TrendingUp',
    roles: ['Leadership'],
  },
  {
    id: 'metrics-config',
    label: 'Metrics Configuration',
    path: '/metrics-configuration',
    icon: 'Tune',
    roles: ['Admin'],
  },
  {
    id: 'data-sources',
    label: 'Data Sources',
    path: '/data-sources',
    icon: 'Storage',
    roles: ['Admin'],
  },
];

export const getNavigationForUser = (userRoles: string[]): NavigationItem[] => {
  return navigationItems.filter(item =>
    item.roles.some(role => userRoles.includes(role))
  );
};

export const getDefaultRoute = (userRoles: string[]): string => {
  if (userRoles.includes('Leadership')) {
    return '/top-level-kpi';
  }
  return '/top-level-kpi';
};
